import { Card, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import clientconfig from "../../Config/clientConfig.json";

import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import { WSIcons } from "../../commonFunctions/iIcons";

export const Product: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const [defaultImg, setDefaultImg] = useState<any | null>(null);
  const { showMessage } = useSnackbar();

  const handleCancelClick = () => {
    navigate("/product/list");
  };
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getProductById(id: any) {
      try {
        const response: any = await callAPI(
          "laundry-products",
          Method.GET,
          {},
          id
        );

        if (response && response?.data) {
          setValue("productName", response.data.productName);
          setDefaultImg(response.data.imageUrl);
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    }
    if (id) {
      getProductById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    try {
      const formData = new FormData();
      formData.append("productName", data.productName);

      if (data.imageUrl) {
        formData.append("image", data.imageUrl[0]);
      }

      const endpoint = id ? `laundry-products/${id}` : "laundry-products";
      const method = id ? Method.PUT : Method.POST;
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(
          endpoint,
          Method.PUTFORMDATA,
          null,
          null,
          formData
        );

        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          response.success === true && navigate("/product/list");
        }
      } else {
        const response: any = await callAPI(endpoint, method, formData, {
          headers: { "Content-Type": "multipart/form-data" } // Important for file uploads
        });

        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          response.success === true && navigate("/product/list");
        }
      }
    } catch (e: any) {
      console.error("error :", e);
      showMessage(e.error);
    }
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];

  const handleUploadFile = (file: any) => {
    setDefaultImg(null);
  };
  return (
    <form onSubmit={handleSubmit(handleData)}>
      <HeaderList title="Add Products" type="card" actions={actions} />
      <Card sx={{ padding: 2, borderRadius: 2 }}>
        <Grid
          item
          container
          spacing={1}
          justifyContent={"start"}
          sx={{
            marginTop: 0,
            marginLeft: 0,
            width: "100%",
            backgroundColor: "#7D79C2",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
          }}
        >
          <Grid
            alignContent={"center"}
            style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
            item
            sm={4}
            className="ws-data-grid-lightviolet-title"
          >
            <Typography variant="h6" id="tableTitle" sx={{ fontSize: "1rem" }}>
              Product Information
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            padding: 3,
            backgroundColor: "#fff",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            border: "1px solid lightgrey"
          }}
        >
          <Grid container spacing={2}>
            {/* Product Name */}
            <Grid item xs={12}>
              <WSTextField
                label={"Name"}
                {...register("productName")}
                id="productName"
                name="productName"
                control={control}
                rules={{ required: "Product name is required" }}
              />
            </Grid>

            {/* Product Type */}
            {/* <Grid item xs={12} sm={6}>
              <WSAutocompleteField
                id="type"
                label="Product Type"
                name="type"
                control={control}
                rules={{ required:false }}
                options={clientconfig.typeOptions.staticOptionData}
              />
            </Grid> */}

            {/* Product Image */}
            <Grid item sm={12} style={{ overflow: "auto" }}>
              <WSFileUpload
                name="imageUrl"
                label="Product Image"
                control={control}
                rules={{ required: defaultImg ? false : true }}
                acceptFileTypes=".jpg,.jpeg,.png"
                maxFileSizeMB={2}
                defaultValue={defaultImg}
                id={"imageUrl"}
                image={true}
                onChange={handleUploadFile}
                align="Start"
                isToolTipImg={false}
                multiple={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </form>
  );
});
